import CrudSalesStateData from 'components/crudSalesStateData/CrudSalesStateData'
import SingleTabCrudContent from 'components/genericCrud/SingleTabCrudContent'
import { CRUD_SALES_STATE_ABM } from 'utils/RoutePath'

export const crudSalesStateDataConfig = {
	id: 'crudSalesState', // igual a la constante del path
	key: 'cod_estado', // nombre de la llave, generalmente ni (número interno) + definición
	descrip: 'descrip', // nombre de la llave uttyilizada para mostrar el nombre del item a modificar
	searchMethod: 'get', // método utilizado en la búsqueda, puede ser GET o POST
	category: 'A', // categoría de ABM, A para normales, C para config
	translation: 'sales_state_data', // nombre de la llave en el archivo de traducciones
	dataUrl: CRUD_SALES_STATE_ABM, // constante de la URL definida en el punto 1.
	urlApi: 'abm_vta_estados', // nombre del root de la API
	component: SingleTabCrudContent, // Componente a utilizar en React
	tabsList: [
		// Lista de TABS si tiene, y si son genéricas ( Básicos, Atributos, Comisiones)
		{
			key: 'basic', // Llave de la tab, puede ser basic, atrib, comission.
			title: 'CRUDS.general_use.basic_tab', // Llave del título en el archivo de traducciones
			tabComponent: CrudSalesStateData // Componente de la Tab en React
		}
	],
	tabsGroupsAlta: ['principal'] // Grupos a utilizar para mostrar los campos del principal y cada tab en orden
}
